'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AppDownloadModal from '@/components/AppDownloadModal';
import BrandsHero from './BrandsHero';
import ROICalculator from './ROICalculator';
import HowCampaignsWork from './HowCampaignsWork';
import PricingSection from './PricingSection';
import CaseStudiesGrid from './CaseStudiesGrid';
import BrandsFAQ from './BrandsFAQ';
import EnterpriseInquiryForm from './EnterpriseInquiryForm';

export default function ForBrandsClient() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Header onDownloadClick={() => setModalOpen(true)} />
      <main>
        <BrandsHero />
        <ROICalculator />
        <HowCampaignsWork />
        <PricingSection />
        <CaseStudiesGrid />
        <EnterpriseInquiryForm />
        <BrandsFAQ />
      </main>
      <Footer />
      <AppDownloadModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}